import { createI18n } from "vue-i18n"

import en from "@/i18n/en.ts";
import de from "@/i18n/de.ts";
import fr from "@/i18n/fr.ts";

const messages = {
  en,
  de,
  fr,
};

export default createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  messages,
  globalInjection: true,
  datetimeFormats: {
    en: {
      dateandtime: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        weekday: "long",
        hour: "2-digit",
        minute: "2-digit",
      },
      dtshort: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      },
      dateonly: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      },
      timeonly: {
        hour: "2-digit",
        minute: "2-digit",
      },
      exacttimeonly: {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
    },
    de: {
      dateandtime: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        weekday: "long",
        hour: "2-digit",
        minute: "2-digit",
      },
      dtshort: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      },
      dateonly: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      },
      timeonly: {
        hour: "2-digit",
        minute: "2-digit",
      },
      exacttimeonly: {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
    },
    fr: {
      dateandtime: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        weekday: "long",
        hour: "2-digit",
        minute: "2-digit",
      },
      dtshort: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      },
      dateonly: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      },
      timeonly: {
        hour: "2-digit",
        minute: "2-digit",
      },
      exacttimeonly: {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
    },
  },
});